import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_ISSUES_METRIC } from '../interfaces/IReportIssues';
import { ANALYTIC_INCIDENCE_DPA_METRIC } from 'modules/dashboard/interfaces/IAnalyticSummarySales';

class AnalyticSummaryIssuesService extends EntityApiService<any> {
  searchByMetric = (metric: ANALYTIC_ISSUES_METRIC, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${metric}`), params, config));
  };

  findOrdersByDPA = (metric: ANALYTIC_INCIDENCE_DPA_METRIC, params?: any, config?: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${metric}`), params, config));
  };
}

export default new AnalyticSummaryIssuesService('/ms-analytics/api/v1/incidence-analytics');
